import { Link } from "react-router-dom";
import { MapPin, Clock, Users, ArrowRight } from "lucide-react";
import { getStatus, showPrice, dateDisplay } from "@/lib/status";

export const TripCard = ({ trip, showVote = false, voteCount = 0, voted = false, onVote }) => {
  const status = getStatus(trip.status);
  const fromPrice = trip.tiers?.basic?.price;
  const dateLabel = dateDisplay(trip);
  return (
    <Link
      to={`/trips/${trip.slug}`}
      data-testid={`trip-card-${trip.slug}`}
      className="group block bg-white border border-black/10 hover:border-ink transition-all duration-300 hover:-translate-y-1 hover:shadow-brutal"
    >
      <div className="relative aspect-[4/5] overflow-hidden">
        <img
          src={trip.image}
          alt={trip.title}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover saturate-[.85] transition-[transform,filter] duration-700 group-hover:scale-105 group-hover:saturate-100"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
        <div className="absolute top-4 left-4 flex flex-wrap gap-2">
          <span className={`text-[10px] font-bold tracking-[0.15em] uppercase px-3 py-1.5 ${status.badge}`} data-testid={`trip-status-${trip.slug}`}>
            {status.label}
          </span>
          {trip.drop_number && (
            <span className="text-[10px] font-bold tracking-[0.15em] uppercase bg-cream text-ink px-3 py-1.5">
              Roamies {trip.drop_number}
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-5 text-cream">
          <h3 className="font-display text-2xl sm:text-3xl uppercase leading-none">{trip.title}</h3>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-3 text-xs font-semibold text-cream/80">
            <span className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" />{trip.destination}</span>
            <span className="flex items-center gap-1.5"><Clock className="w-3.5 h-3.5" />{dateLabel}</span>
            <span className="flex items-center gap-1.5"><Users className="w-3.5 h-3.5" />Ages {trip.age_min || 18}–{trip.age_max || 45} · {trip.group_size}</span>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between px-5 py-4">
        <div>
          <p className="text-[10px] font-bold tracking-[0.2em] uppercase text-ink/50">
            {trip.trip_style || (trip.category === "flagship" ? "Flagship International" : "Weekend Getaway")} · {trip.duration}
          </p>
          {showPrice(trip.status) && (fromPrice || trip.price_label) ? (
            <p className="font-display text-2xl text-ink mt-1" data-testid={`trip-price-${trip.slug}`}>
              {fromPrice ? `from $${fromPrice.toLocaleString()}` : trip.price_label}
            </p>
          ) : (
            <p className="text-xs font-bold uppercase tracking-widest text-flame mt-2">Pricing Coming Soon</p>
          )}
        </div>
        <span className="group/cta inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-flame">
          View trip <ArrowRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-1" />
        </span>
      </div>
      {showVote && (
        <div className="px-5 pb-4">
          <button
            onClick={(e) => { e.preventDefault(); onVote && onVote(trip.slug); }}
            data-testid={`vote-btn-${trip.slug}`}
            className={`w-full h-9 text-[10px] font-bold uppercase tracking-[0.2em] border transition-colors ${voted ? "bg-flame text-white border-flame" : "border-ink/20 text-ink hover:border-flame hover:text-flame"}`}
          >
            {voted ? "Voted" : "Vote for this trip"} · {voteCount || 0}
          </button>
        </div>
      )}
    </Link>
  );
};

